<template>
  <v-select
    v-bind="$attrs"
    :selectable="isSelectable"
    v-on="$listeners"
  >
    <!-- Custom option slot: show DELETED badge for deleted items -->
    <template #option="option">
      <div
        style="
          display: flex;
          justify-content: space-between;
          align-items: center;
        "
      >
        <span>{{ getOptionLabel(option) }}</span>
        <span
          v-if="option.deleted"
          style="
            color: red;
            font-weight: bold;
            font-size: 0.7em;
            text-transform: uppercase;
            margin-left: 8px;
            margin-right: 15px;
          "
        >
          DELETED
        </span>
      </div>
    </template>

    <!-- Custom selected-option slot: show DELETED badge for selected items -->
    <template #selected-option="option">
      <div style="display: flex; align-items: center">
        <span>{{ getOptionLabel(option) }}</span>
        <span
          v-if="option.deleted"
          style="
            color: red;
            font-weight: bold;
            font-size: 0.7em;
            text-transform: uppercase;
            margin-left: 8px;
          "
        >
          (DELETED)
        </span>
      </div>
    </template>

    <!-- Pass through all other slots from parent -->
    <template
      v-for="(_, slotName) in $scopedSlots"
      #[slotName]="slotData"
    >
      <slot
        :name="slotName"
        v-bind="slotData || {}"
      />
    </template>
  </v-select>
</template>

<script>
import vSelect from 'vue-select'

export default {
  name: 'MasterSelect',
  components: {
    vSelect,
  },
  inheritAttrs: false,
  methods: {
    isSelectable(option) {
      return !option.deleted
    },
    getOptionLabel(option) {
      // Use the same label prop that was passed to v-select via $attrs
      const labelKey = this.$attrs.label || 'label'
      return option[labelKey]
    },
  },
}
</script>

<style scoped>
/* Style disabled (deleted) options to look visually muted */
::v-deep .vs__dropdown-option--disabled {
  opacity: 0.6;
  cursor: not-allowed;
}
</style>
